// extracted by mini-css-extract-plugin
export default {"order":"OrderMx_order__yetDf","orderHeader":"OrderMx_orderHeader__wnKpp","icon":"OrderMx_icon__-cVkG","return":"OrderMx_return__oL5tB","returnText":"OrderMx_returnText__539Xk"};